import { cn as e } from "../shared/utils.js";
import { Button as t } from "../button/primitive/button.js";
import { AlertTriangleIcon as n, CheckCircleIcon as r, InfoCircleIcon as i, XCircleIcon as a, XIcon as o } from "@systemeio/icons";
import { forwardRef as s } from "react";
import { jsx as c, jsxs as l } from "react/jsx-runtime";
import { Toast as u } from "@base-ui/react/toast";
//#region src/toast/toast.tsx
var d = {
	success: r,
	warning: n,
	error: a,
	info: i
};
function f(e) {
	let t = e.startsWith("top") ? "up" : "down";
	return e.includes("center") ? [t] : e.includes("left") ? ["left", t] : ["right", t];
}
function p(e) {
	let [t, n] = e.split("-");
	return {
		vertical: t,
		horizontal: n
	};
}
function m({ position: t, portalProps: n }) {
	let r = t === void 0, i = t ?? "top-right", { toasts: a } = u.useToastManager(), o = f(i), { vertical: s, horizontal: m } = p(i);
	return /* @__PURE__ */ c(u.Portal, {
		"data-slot": "toast-portal",
		"data-testid": "toast-portal",
		...n,
		children: /* @__PURE__ */ c(u.Viewport, {
			"aria-label": "Notifications",
			className: e("fixed isolate z-[9999] m-1 flex list-none flex-col items-center p-0 outline-none", r ? "tablet:top-20 tablet:right-4 tablet:left-auto tablet:mx-0 tablet:w-[426px] tablet:max-w-[426px] tablet:translate-x-0 inset-x-4 top-5 mx-auto w-[343px] max-w-[calc(100vw-32px)]" : "w-[calc(100%-2rem)] max-w-[426px]", !r && (s === "top" ? "top-5" : "bottom-5"), !r && m === "left" && "right-auto left-4 translate-x-0", !r && m === "center" && "right-auto left-1/2 -translate-x-1/2", !r && m === "right" && "right-4 left-auto translate-x-0"),
			"data-position": i,
			"data-slot": "toast-viewport",
			"data-testid": "toast-viewport",
			children: a.map((e) => {
				let t = e.type ? d[e.type] : null;
				return /* @__PURE__ */ c(v, {
					toast: e,
					swipeDirection: o,
					"data-position": i,
					children: /* @__PURE__ */ l(y, { children: [
						t && /* @__PURE__ */ c(b, { children: /* @__PURE__ */ c(t, {}) }),
						/* @__PURE__ */ l("div", {
							className: "flex min-w-0 flex-1 flex-col gap-1",
							children: [
								/* @__PURE__ */ c(x, {}),
								/* @__PURE__ */ c(S, {}),
								e.actionProps && /* @__PURE__ */ c(C, {
									className: "self-start",
									onClick: e.actionProps.onClick,
									children: e.actionProps.children
								})
							]
						}),
						/* @__PURE__ */ c(T, {})
					] })
				}, e.id);
			})
		})
	});
}
var h = u.createToastManager();
function g({ children: e, position: t, portalProps: n, ...r }) {
	return /* @__PURE__ */ l(u.Provider, {
		"data-slot": "toast-provider",
		"data-testid": "toast-provider",
		toastManager: h,
		...r,
		children: [e, /* @__PURE__ */ c(m, {
			position: t,
			portalProps: n
		})]
	});
}
var _ = s(function({ className: t, ...n }, r) {
	return /* @__PURE__ */ c(u.Viewport, {
		ref: r,
		"data-slot": "toast-viewport",
		"data-testid": "toast-viewport",
		"aria-label": "Notifications",
		className: e("fixed isolate z-[9999] m-1 flex list-none flex-col items-center p-0 outline-none", "tablet:top-20 tablet:right-4 tablet:left-auto tablet:mx-0 tablet:w-[426px] tablet:max-w-[426px] tablet:translate-x-0 inset-x-4 top-5 mx-auto w-[343px] max-w-[calc(100vw-32px)]", t),
		...n
	});
}), v = s(function({ className: t, ...n }, r) {
	return /* @__PURE__ */ c(u.Root, {
		ref: r,
		"data-slot": "toast-root",
		"data-testid": "toast-root",
		className: e("absolute top-0 right-0 left-auto z-[calc(1000-var(--toast-index))] origin-top", "data-[position*=bottom]:top-auto data-[position*=bottom]:bottom-0 data-[position*=bottom]:origin-bottom", "h-(--height) w-full", "transform-[translateX(var(--toast-swipe-movement-x))_translateY(calc(var(--toast-swipe-movement-y)+(var(--toast-index)*var(--peek))+(var(--shrink)*var(--height))))_scale(var(--scale))]", "data-[position*=bottom]:transform-[translateX(var(--toast-swipe-movement-x))_translateY(calc(var(--toast-swipe-movement-y)-(var(--toast-index)*var(--peek))-(var(--shrink)*var(--height))))_scale(var(--scale))]", "bg-bg-primary border-border-100 shadow-4 rounded-xl border p-4 opacity-(--toast-opacity) data-expanded:opacity-100 sm:p-5", "focus-visible:focus-ring-primary", "select-none", "[--gap:0.5rem] [--height:var(--toast-frontmost-height,var(--toast-height))]", "[--offset-y:calc(var(--toast-offset-y)+calc(var(--toast-index)*var(--gap))+var(--toast-swipe-movement-y))]", "data-[position*=bottom]:[--offset-y:calc(var(--toast-offset-y)*-1+calc(var(--toast-index)*var(--gap)*-1)+var(--toast-swipe-movement-y))]", "[--peek:0.5rem] [--scale:calc(max(0,1-(var(--toast-index)*0.02)))] [--shrink:calc(1-var(--scale))] [--toast-opacity:calc(1-(var(--toast-index)*0.2))]", "[transition:opacity_300ms_ease-out,transform_150ms_ease-in-out,height_150ms_ease-in-out]", "after:absolute after:bottom-full after:left-0 after:h-[calc(var(--gap)+1px)] after:w-full after:content-[\"\"]", "data-[position*=bottom]:after:top-full", "data-starting-style:transform-[translateX(calc(100%+24px))] data-starting-style:opacity-0", "data-[position*=bottom]:data-starting-style:transform-[translateY(150%)]", "data-ending-style:opacity-0 data-ending-style:[transition:opacity_150ms_ease-in,transform_150ms_ease-in,height_150ms_ease-in-out]", "data-[slot=toast-root]:data-expanded:h-(--toast-height) data-[slot=toast-root]:data-expanded:transform-[translateX(var(--toast-swipe-movement-x))_translateY(var(--offset-y))]", "data-limited:opacity-0", "[&[data-ending-style]:not([data-limited]):not([data-swipe-direction])]:transform-[translateX(calc(100%+24px))]", "data-[position*=bottom]:[&[data-ending-style]:not([data-limited]):not([data-swipe-direction])]:transform-[translateY(150%)]", "data-ending-style:data-[swipe-direction=down]:transform-[translateY(calc(var(--toast-swipe-movement-y)+150%))] data-expanded:data-ending-style:data-[swipe-direction=down]:transform-[translateY(calc(var(--toast-swipe-movement-y)+150%))]", "data-ending-style:data-[swipe-direction=left]:transform-[translateX(calc(var(--toast-swipe-movement-x)-150%))_translateY(var(--offset-y))] data-expanded:data-ending-style:data-[swipe-direction=left]:transform-[translateX(calc(var(--toast-swipe-movement-x)-150%))_translateY(var(--offset-y))]", "data-ending-style:data-[swipe-direction=right]:transform-[translateX(calc(var(--toast-swipe-movement-x)+150%))_translateY(var(--offset-y))] data-expanded:data-ending-style:data-[swipe-direction=right]:transform-[translateX(calc(var(--toast-swipe-movement-x)+150%))_translateY(var(--offset-y))]", "data-ending-style:data-[swipe-direction=up]:transform-[translateY(calc(var(--toast-swipe-movement-y)-150%))] data-expanded:data-ending-style:data-[swipe-direction=up]:transform-[translateY(calc(var(--toast-swipe-movement-y)-150%))]", t),
		...n
	});
}), y = s(function({ className: t, ...n }, r) {
	return /* @__PURE__ */ c(u.Content, {
		ref: r,
		"data-slot": "toast-content",
		"data-testid": "toast-content",
		className: e("flex h-full min-w-0 items-center gap-4 opacity-100 transition-opacity duration-150 ease-in-out has-data-[slot=toast-action]:items-start has-data-[slot=toast-description]:items-start data-expanded:opacity-100", t),
		...n
	});
}), b = s(function({ children: t, className: n }, r) {
	return /* @__PURE__ */ c("span", {
		ref: r,
		"data-slot": "toast-icon",
		"data-testid": "toast-icon",
		className: e("flex size-[34px] shrink-0 items-center justify-center rounded-full p-2", "in-data-[type=success]:bg-system-success-100 in-data-[type=success]:text-system-success-700", "in-data-[type=warning]:bg-system-warning-100 in-data-[type=warning]:text-system-warning-700", "in-data-[type=error]:bg-system-error-100 in-data-[type=error]:text-system-error-700", "in-data-[type=info]:bg-system-primary-100 in-data-[type=info]:text-system-primary-700", n),
		children: /* @__PURE__ */ c("span", {
			"data-slot": "toast-icon-content",
			"data-testid": "toast-icon-content",
			className: "flex size-[18px] items-center justify-center [&_svg]:size-full",
			children: t
		})
	});
}), x = s(function({ className: t, ...n }, r) {
	return /* @__PURE__ */ c(u.Title, {
		ref: r,
		"data-slot": "toast-title",
		"data-testid": "toast-title",
		className: e("text-text-primary text-base font-medium", t),
		...n
	});
}), S = s(function({ className: t, ...n }, r) {
	return /* @__PURE__ */ c(u.Description, {
		ref: r,
		"data-slot": "toast-description",
		"data-testid": "toast-description",
		className: e("text-text-tertiary text-base", t),
		...n
	});
}), C = s(function({ className: t, ...n }, r) {
	return /* @__PURE__ */ c(u.Action, {
		ref: r,
		"data-slot": "toast-action",
		"data-testid": "toast-action",
		className: e("border-button-secondary-border bg-button-secondary text-text-primary hover:bg-button-secondary-hover inline-flex h-8 w-fit cursor-pointer items-center justify-center rounded-md border px-3 text-sm font-medium transition-colors", "focus-visible:focus-ring-primary", t),
		...n
	});
}), w = s(function({ className: t, ...n }, r) {
	return /* @__PURE__ */ c(u.Close, {
		ref: r,
		"data-slot": "toast-close",
		"data-testid": "toast-close",
		className: e("text-text-tertiary hover:text-text-secondary size-8 shrink-0 cursor-pointer rounded-md transition-colors", "focus-visible:focus-ring-primary", t),
		...n
	});
}), T = s(function({ children: e, ...n }, r) {
	return /* @__PURE__ */ c(w, {
		ref: r,
		"data-slot": "toast-close-button",
		"data-testid": "toast-close-button",
		"aria-label": "Close",
		...n,
		render: /* @__PURE__ */ c(t, {
			variant: "ghost-gray",
			size: "icon-sm"
		}),
		children: e ?? /* @__PURE__ */ c(o, {})
	});
});
_.displayName = u.Viewport.displayName, v.displayName = u.Root.displayName, y.displayName = u.Content.displayName, b.displayName = "ToastIcon", x.displayName = u.Title.displayName, S.displayName = u.Description.displayName, C.displayName = u.Action.displayName, w.displayName = u.Close.displayName, T.displayName = "ToastCloseButton", m.displayName = "Toasts", g.displayName = "ToastProvider";
var E = {
	Provider: u.Provider,
	Portal: u.Portal,
	Viewport: _,
	Root: v,
	Content: y,
	Icon: b,
	Title: x,
	Description: S,
	Action: C,
	Close: w,
	CloseButton: T,
	Toasts: m,
	ToastProvider: g,
	useToastManager: u.useToastManager,
	createToastManager: u.createToastManager
};
//#endregion
export { E as Toast, g as ToastProvider, m as Toasts, h as toastManager };
